export default [
  {
    path: 'material',
    name: 'material',
    component: () => import('@/views/admin/material/material.vue'),
    meta: { title: '素材' },
    children: [
      {
        path: 'expression/list',
        component: () => import('@/views/admin/material/expression/list.vue'),
        meta: { title: '表情列表' }
      },
      {
        path: 'expression/upsert',
        component: () => import('@/views/admin/material/expression/upsert.vue'),
        meta: { title: '添加/编辑头像' }
      },
      {
        path: 'avatar/list',
        component: () => import('@/views/admin/material/avatar/list.vue'),
        meta: { title: '头像列表' }
      },
      {
        path: 'avatar/upsert',
        component: () => import('@/views/admin/material/avatar/upsert.vue'),
        meta: { title: '添加/编辑头像' }
      },
      {
        path: 'template/list',
        component: () => import('@/views/admin/material/template/list.vue'),
        meta: { title: '模板列表' }
      },
      {
        path: 'template/upsert',
        component: () => import('@/views/admin/material/template/upsert.vue'),
        meta: { title: '添加/编辑模板' }
      },
      {
        path: 'image/list',
        component: () => import('@/views/admin/material/image/list.vue'),
        meta: { title: '图片列表' }
      },
      {
        path: 'image/upsert',
        component: () => import('@/views/admin/material/image/upsert.vue'),
        meta: { title: '添加/编辑图片' }
      },
      {
        path: 'ip/list',
        component: () => import('@/views/admin/material/ip/list.vue'),
        meta: { title: '角色列表' }
      },
      {
        path: 'ip/upsert',
        component: () => import('@/views/admin/material/ip/upsert.vue'),
        meta: { title: '添加/编辑角色' }
      },
      {
        path: 'ssip/list',
        component: () => import('@/views/admin/material/ssip/list.vue'),
        meta: { title: '数字人列表' }
      },
      {
        path: 'ssip/upsert',
        component: () => import('@/views/admin/material/ssip/upsert.vue'),
        meta: { title: '添加/编辑数字人' }
      }
    ]
  }
]
